if (!customElements.get('hero-particles')) {
  class HeroParticles extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      requestAnimationFrame(() => this.init());
    }

    init() {
      const type = this.dataset.type || 'bubbles';
      const density = parseInt(this.dataset.density || '50', 10);
      const width = this.offsetWidth || 800;
      const count = Math.min(Math.floor((width / 50) * (density / 10)), 60);
      const rnd = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
      const frag = document.createDocumentFragment();

      for (let i = 0; i < count; i++) {
        const span = document.createElement('span');
        span.className = 'particle';

        switch (type) {
          case 'bubbles': {
            const size = rnd(40, 80) / 10;
            span.style.cssText = `top:${rnd(0, 100)}%;left:${rnd(0, 95)}%;width:${size}px;height:${size}px;animation-delay:${rnd(0, 30) / 10}s`;
            break;
          }
          case 'hearts': {
            const size = rnd(6, 12);
            span.style.cssText = `top:${rnd(0, 100)}%;left:${rnd(0, 95)}%;width:${size}px;height:${size}px;animation-delay:${rnd(0, 30) / 10}s`;
            break;
          }
          case 'lines': {
            const h = rnd(10, 30);
            span.style.cssText = `top:${rnd(0, 100)}%;left:${rnd(0, 95)}%;width:1px;height:${h}px;animation-delay:${rnd(0, 30) / 10}s`;
            break;
          }
          case 'confetti': {
            span.classList.add(Math.random() > 0.5 ? 'c1' : 'c2');
            const w = rnd(4, 8);
            const h = rnd(4, 12);
            span.style.cssText = `top:${rnd(0, 95)}%;left:${rnd(0, 95)}%;width:${w}px;height:${h}px;animation-delay:${rnd(0, 30) / 10}s`;
            break;
          }
          case 'fire': {
            const size = rnd(8, 20);
            span.style.cssText = `bottom:${rnd(0, 40)}%;left:${rnd(10, 90)}%;width:${size}px;height:${size}px;animation-delay:${rnd(0, 8) / 10}s`;
            break;
          }
          case 'sunbeams': {
            const w = rnd(2, 4);
            const h = rnd(40, 100);
            span.style.cssText = `top:${rnd(0, 95)}%;left:${rnd(0, 95)}%;width:${w}px;height:${h}px;animation-delay:${rnd(0, 30) / 10}s`;
            break;
          }
        }

        frag.appendChild(span);
      }

      this.appendChild(frag);
    }

    disconnectedCallback() {
      while (this.firstChild) {
        this.removeChild(this.firstChild);
      }
    }
  }

  customElements.define('hero-particles', HeroParticles);
}
